// AUTOGENERATED - MANUALLY CHANGES WILL BE REVERTED BY THE GENERATOR
// https://arbiscan.io/address/0xe4c892BE702F8e0771122CCaAA0E50BF9639e2Fd
export const SVR_USDC__USD = '0xe4c892BE702F8e0771122CCaAA0E50BF9639e2Fd';

// https://arbiscan.io/address/0x7C7dFfEC76F590e9648ea468bA2fDd0A9892A595
export const SVR_USDC__USD_BASE = '0x7C7dFfEC76F590e9648ea468bA2fDd0A9892A595';

// https://arbiscan.io/address/0x8d0CC5f38f9E802475f2CFf4F9fc7000C2E1557c
export const AAPL__USD = '0x8d0CC5f38f9E802475f2CFf4F9fc7000C2E1557c';

// https://arbiscan.io/address/0x3d9145b5804E13Bc14d19c3DDbd3DA8fD02b5034
export const AB__USD = '0x3d9145b5804E13Bc14d19c3DDbd3DA8fD02b5034';

// https://arbiscan.io/address/0x72B424C9A254481626535dBb1Aa3175C08F15943
export const AAVE_SVR_GHO__USD = '0x72B424C9A254481626535dBb1Aa3175C08F15943';

// https://arbiscan.io/address/0xAE0d73C9a489084531deEdCa6765fA3396db49c1
export const AAVE_SVR_GHO__USD_BASE = '0xAE0d73C9a489084531deEdCa6765fA3396db49c1';

// https://arbiscan.io/address/0x46306F3795342117721D8DEd50fbcF6DF2b3cc10
export const SPY__USD = '0x46306F3795342117721D8DEd50fbcF6DF2b3cc10';

// https://arbiscan.io/address/0x205aaD468a11fd5D34fA7211bC6Bad5b3deB9b98
export const OP__USD = '0x205aaD468a11fd5D34fA7211bC6Bad5b3deB9b98';

// https://arbiscan.io/address/0x4881A4418b5F2460B21d6F08CD5aA0678a7f262F
export const NVDA__USD = '0x4881A4418b5F2460B21d6F08CD5aA0678a7f262F';

// https://arbiscan.io/address/0xC56765f04B248394CF1619D20dB8082Edbfa75b1
export const XAG__USD = '0xC56765f04B248394CF1619D20dB8082Edbfa75b1';

// https://arbiscan.io/address/0xF3272CAfe65b190e76caAF483db13424a3e23dD2
export const rETH_ETH_Exchange_Rate = '0xF3272CAfe65b190e76caAF483db13424a3e23dD2';

// https://arbiscan.io/address/0x87121F6c9A9F6E90E59591E4Cf4804873f54A95b
export const MIM__USD = '0x87121F6c9A9F6E90E59591E4Cf4804873f54A95b';

// https://arbiscan.io/address/0xf9ce4fE2F0EcE0362cb416844AE179a49591D567
export const HYPE__USD = '0xf9ce4fE2F0EcE0362cb416844AE179a49591D567';

// https://arbiscan.io/address/0x6BC7fF3C21f005684ef834FBA4d88459e988CcdC
export const WSTUSR_STUSR_Exchange_Rate = '0x6BC7fF3C21f005684ef834FBA4d88459e988CcdC';

// https://arbiscan.io/address/0x496DC5AAbf2f118D78816B7358e69dC784D3De65
export const AoABT_Reserves = '0x496DC5AAbf2f118D78816B7358e69dC784D3De65';

// https://arbiscan.io/address/0xD0E31451f58d3991045D68C479ea80D37e418851
export const GLV_WETH_USDC_USD = '0xD0E31451f58d3991045D68C479ea80D37e418851';

// https://arbiscan.io/address/0xe4dF63Bf89fD868A899F2422B030709FD79Be921
export const SVR_ETH__USD = '0xe4dF63Bf89fD868A899F2422B030709FD79Be921';

// https://arbiscan.io/address/0xe4D040128CFdF03eC221832251caC9b6f0515E3f
export const SVR_ETH__USD_BASE = '0xe4D040128CFdF03eC221832251caC9b6f0515E3f';

// https://arbiscan.io/address/0x4b13Dd76De990Db9A2Dab58D35C2c02E5e3AE848
export const WLFI__USD = '0x4b13Dd76De990Db9A2Dab58D35C2c02E5e3AE848';

// https://arbiscan.io/address/0x866fa212dfc5AAf321379874eCe95631F6d12e00
export const HSK__USD = '0x866fa212dfc5AAf321379874eCe95631F6d12e00';

// https://arbiscan.io/address/0xb523AE262D20A936BC152e6023996e46FDC2A95D
export const WSTETH__ETH = '0xb523AE262D20A936BC152e6023996e46FDC2A95D';

// https://arbiscan.io/address/0x4050bD8263771f8BBded08C299BD944488a91AaD
export const instETH__ETH_Exchange_Rate = '0x4050bD8263771f8BBded08C299BD944488a91AaD';

// https://arbiscan.io/address/0x3609baAa0a9b1f0FE4d6CC01884585d0e191C3E3
export const TSLA__USD = '0x3609baAa0a9b1f0FE4d6CC01884585d0e191C3E3';

// https://arbiscan.io/address/0x21E1a03da332F9277A6839d1EF182d07644d1875
export const AAVE_SVR_USDT__USD = '0x21E1a03da332F9277A6839d1EF182d07644d1875';

// https://arbiscan.io/address/0xfF6B58D50dADf1EcC69101B2784b2ebb2edc30F6
export const AAVE_SVR_USDT__USD_BASE = '0xfF6B58D50dADf1EcC69101B2784b2ebb2edc30F6';

// https://arbiscan.io/address/0x37833E5b3fbbEd4D613a3e0C354eF91A42B81eeB
export const USDS__USD = '0x37833E5b3fbbEd4D613a3e0C354eF91A42B81eeB';

// https://arbiscan.io/address/0xcAc0138592090762385CCB7bb94C9401F734Eb30
export const USD1__USD = '0xcAc0138592090762385CCB7bb94C9401F734Eb30';

// https://arbiscan.io/address/0xE9Bd4Ca2CDacb56cd06c9C4C5231e69c33340B3c
export const USDG__USD = '0xE9Bd4Ca2CDacb56cd06c9C4C5231e69c33340B3c';

// https://arbiscan.io/address/0xDbFF913E9058C1E60446150D23Bb0fFE9144d531
export const AAVE_SVR_USDC__USD = '0xDbFF913E9058C1E60446150D23Bb0fFE9144d531';

// https://arbiscan.io/address/0x0D0FaDDd42C53fc6d1b933C7ccccCFaF9B79B571
export const AAVE_SVR_USDC__USD_BASE = '0x0D0FaDDd42C53fc6d1b933C7ccccCFaF9B79B571';

// https://arbiscan.io/address/0x17d8D87dF3E279c737568aB0C5cC3fF750aB763e
export const DOLO__USD = '0x17d8D87dF3E279c737568aB0C5cC3fF750aB763e';

// https://arbiscan.io/address/0x3815dd45CDe3BfAf1E3db6D7FF9EF3b437d6D0E0
export const TAC__USD = '0x3815dd45CDe3BfAf1E3db6D7FF9EF3b437d6D0E0';

// https://arbiscan.io/address/0x1D1a83331e9D255EB1Aaf75026B60dFD00A252ba
export const GOOGL__USD = '0x1D1a83331e9D255EB1Aaf75026B60dFD00A252ba';

// https://arbiscan.io/address/0xD6aB2298946840262FcC278fF31516D39fF611eF
export const RETH__ETH = '0xD6aB2298946840262FcC278fF31516D39fF611eF';

// https://arbiscan.io/address/0x0017abAc5b6f291F9164e35B1234CA1D697f9CF4
export const WBTC__BTC = '0x0017abAc5b6f291F9164e35B1234CA1D697f9CF4';

// https://arbiscan.io/address/0x3a9659C071dD3C37a8b1A2363409A8D41B2Feae3
export const STX__USD = '0x3a9659C071dD3C37a8b1A2363409A8D41B2Feae3';

// https://arbiscan.io/address/0x03a1f4b19aaeA6e68f0f104dc4346dA3E942cC45
export const wOETH__OETH_Exchange_Rate = '0x03a1f4b19aaeA6e68f0f104dc4346dA3E942cC45';

// https://arbiscan.io/address/0xB4AD57B52aB9141de9926a3e0C8dc6264c2ef205
export const XRP__USD = '0xB4AD57B52aB9141de9926a3e0C8dc6264c2ef205';

// https://arbiscan.io/address/0xcC3370Bde6AFE51e1205a5038947b9836371eCCb
export const CNY__USD = '0xcC3370Bde6AFE51e1205a5038947b9836371eCCb';

// https://arbiscan.io/address/0x413b219D371C352f6d1E9A39f5CE4c869EdA9476
export const KAIA__USD = '0x413b219D371C352f6d1E9A39f5CE4c869EdA9476';

// https://arbiscan.io/address/0xbF539d4c2106dd4D9AB6D56aed3d9023529Db145
export const KNC__USD = '0xbF539d4c2106dd4D9AB6D56aed3d9023529Db145';

// https://arbiscan.io/address/0x0411D28c94d85A36bC72Cb0f875dfA8371D8fFfF
export const LUSD__USD = '0x0411D28c94d85A36bC72Cb0f875dfA8371D8fFfF';

// https://arbiscan.io/address/0x85bb02E0Ae286600d1c68Bb6Ce22Cc998d411916
export const KRW__USD = '0x85bb02E0Ae286600d1c68Bb6Ce22Cc998d411916';

// https://arbiscan.io/address/0x4a85B128EBDaFC24d5CB611e161376ffDECeB289
export const SUI__USD = '0x4a85B128EBDaFC24d5CB611e161376ffDECeB289';

// https://arbiscan.io/address/0x50834F3163758fcC1Df9973b6e91f0F0F0434aD3
export const USDC__USD = '0x50834F3163758fcC1Df9973b6e91f0F0F0434aD3';

// https://arbiscan.io/address/0x5F25Ea8Cf2a3aB12E4D6fB58FB63C7938473B036
export const aBTC_Proof_of_Reserves = '0x5F25Ea8Cf2a3aB12E4D6fB58FB63C7938473B036';

// https://arbiscan.io/address/0x221912ce795669f628c51c69b7d0873eDA9C03bB
export const APE__USD = '0x221912ce795669f628c51c69b7d0873eDA9C03bB';

// https://arbiscan.io/address/0xa6bC5bAF2000424e90434bA7104ee399dEe80DEc
export const DOT__USD = '0xa6bC5bAF2000424e90434bA7104ee399dEe80DEc';

// https://arbiscan.io/address/0xEcD471ef663eCEFFC7D731a0C7e51007433e6d6e
export const swETH__ETH_Exchange_Rate = '0xEcD471ef663eCEFFC7D731a0C7e51007433e6d6e';

// https://arbiscan.io/address/0x2BA975D4D7922cD264267Af16F3bD177F206FE3c
export const PAXG__USD = '0x2BA975D4D7922cD264267Af16F3bD177F206FE3c';

// https://arbiscan.io/address/0x5698690a7B7B84F6aa985ef7690A8A7288FBc9c8
export const LTC__USD = '0x5698690a7B7B84F6aa985ef7690A8A7288FBc9c8';

// https://arbiscan.io/address/0x0301e5D0A8f7490444ebd1921E3d0f0fe7722786
export const TON__USD = '0x0301e5D0A8f7490444ebd1921E3d0f0fe7722786';

// https://arbiscan.io/address/0x11E1836bFF2ce9d6A5bec9cA79dc998210f3886d
export const ezETH__ETH = '0x11E1836bFF2ce9d6A5bec9cA79dc998210f3886d';

// https://arbiscan.io/address/0xb966F82183E41208f594586BBF04bb6163571C48
export const RYT_Arbitrum__Proof_of_Reserves = '0xb966F82183E41208f594586BBF04bb6163571C48';

// https://arbiscan.io/address/0xfb010c715Ff2B85DB9c896f0C030bF9329638905
export const FBTC_Proof_of_Reserves = '0xfb010c715Ff2B85DB9c896f0C030bF9329638905';

// https://arbiscan.io/address/0x86e5D529Cb7cAeF5C475Aab0727a84739E12EA3F
export const AAVE_SVR_EURC__USD = '0x86e5D529Cb7cAeF5C475Aab0727a84739E12EA3F';

// https://arbiscan.io/address/0x671eE94eCE3c0D19D0F69CB1718aa9150daA8Ea6
export const AAVE_SVR_EURC__USD_BASE = '0x671eE94eCE3c0D19D0F69CB1718aa9150daA8Ea6';

// https://arbiscan.io/address/0x6548a81E640C000150e06AB413fB3F772682e9c5
export const USDPlus__USD = '0x6548a81E640C000150e06AB413fB3F772682e9c5';

// https://arbiscan.io/address/0x7A58648CAeA88e042767823723aF266DC6c4c4D9
export const stBTC__BTC_Exchange_Rate = '0x7A58648CAeA88e042767823723aF266DC6c4c4D9';

// https://arbiscan.io/address/0x3EAbF62EB761BD86c71d07AdBb1A9183FeC24064
export const SVR_LINK__USD = '0x3EAbF62EB761BD86c71d07AdBb1A9183FeC24064';

// https://arbiscan.io/address/0xA841011089336de36b239b49f70A456EdD1c87c8
export const SVR_LINK__USD_BASE = '0xA841011089336de36b239b49f70A456EdD1c87c8';

// https://arbiscan.io/address/0x639Fe6ab55C921f74e7fac1ee960C0B6293ba612
export const ETH__USD = '0x639Fe6ab55C921f74e7fac1ee960C0B6293ba612';

// https://arbiscan.io/address/0xf2215b9c35b1697B5f47e407c917a40D055E68d7
export const sUSDe__USD = '0xf2215b9c35b1697B5f47e407c917a40D055E68d7';

// https://arbiscan.io/address/0x054296f0D036b95531B4E14aFB578B80CFb41252
export const SNX__USD = '0x054296f0D036b95531B4E14aFB578B80CFb41252';

// https://arbiscan.io/address/0x05Bc6e5Fb110589bb366A3Cd7CdBe143EeBA2168
export const SWETH__ETH = '0x05Bc6e5Fb110589bb366A3Cd7CdBe143EeBA2168';

// https://arbiscan.io/address/0x9fa74925F21ad6C86d8f402EF490cFbA2Fa5e9bE
export const LBTC__BTC = '0x9fa74925F21ad6C86d8f402EF490cFbA2Fa5e9bE';

// https://arbiscan.io/address/0x875C69Da7AE092E4Dc277171e9c373718DDB25E2
export const yUSD__USD_Exchange_Rate = '0x875C69Da7AE092E4Dc277171e9c373718DDB25E2';

// https://arbiscan.io/address/0x640F0B3e8Ee59bD7310C3E16B93f4c6612CC1130
export const vyUSD__USD_Exchange_Rate = '0x640F0B3e8Ee59bD7310C3E16B93f4c6612CC1130';

// https://arbiscan.io/address/0x8f1dF6D7F2db73eECE86a18b4381F4707b918FB1
export const wrsETH__rsETH_Exchange_Rate = '0x8f1dF6D7F2db73eECE86a18b4381F4707b918FB1';

// https://arbiscan.io/address/0xaD1d5344AaDE45F43E596773Bcc4c423EAbdD034
export const AAVE__USD = '0xaD1d5344AaDE45F43E596773Bcc4c423EAbdD034';

// https://arbiscan.io/address/0xc5a90A6d7e4Af242dA238FFe279e9f2BA0c64B2e
export const BTC__ETH = '0xc5a90A6d7e4Af242dA238FFe279e9f2BA0c64B2e';

// https://arbiscan.io/address/0x851175a919f36c8e30197c09a9A49dA932c2CC00
export const CVX__USD = '0x851175a919f36c8e30197c09a9A49dA932c2CC00';

// https://arbiscan.io/address/0x926Eed7973EBc57a8767659C5b35b9a0bAB6302f
export const Real_Final_Sales_to_Private_Domestic_Purchasers_Level =
  '0x926Eed7973EBc57a8767659C5b35b9a0bAB6302f';

// https://arbiscan.io/address/0x3c786e934F23375Ca345C9b8D5aD54838796E8e7
export const GHO__USD = '0x3c786e934F23375Ca345C9b8D5aD54838796E8e7';

// https://arbiscan.io/address/0x6AA147E11E423F529BEDAed75F3128D5fbE67939
export const SVR_USDT__USD = '0x6AA147E11E423F529BEDAed75F3128D5fbE67939';

// https://arbiscan.io/address/0x158B2203D267a50BE9b7930D13d8247A4968D659
export const SVR_USDT__USD_BASE = '0x158B2203D267a50BE9b7930D13d8247A4968D659';

// https://arbiscan.io/address/0x47C38C695639aE97A00f57D6D9f5ece1DebB033C
export const _0G__USD = '0x47C38C695639aE97A00f57D6D9f5ece1DebB033C';

// https://arbiscan.io/address/0x9854e9a850e7C354c1de177eA953a6b1fba8Fc22
export const AUD__USD = '0x9854e9a850e7C354c1de177eA953a6b1fba8Fc22';

// https://arbiscan.io/address/0x0d20576Fae18e89A28e75B63BFce5D1B8586d739
export const AAVE_Network_Emergency_Count_Arbitrum = '0x0d20576Fae18e89A28e75B63BFce5D1B8586d739';

// https://arbiscan.io/address/0xF0b7159BbFc341Cc41E7Cb182216F62c6d40533D
export const RPL__USD = '0xF0b7159BbFc341Cc41E7Cb182216F62c6d40533D';

// https://arbiscan.io/address/0x5Fb73f7Af8a29297953d3611422826039338E5b4
export const ankrETH__ETH_Exchange_Rate = '0x5Fb73f7Af8a29297953d3611422826039338E5b4';

// https://arbiscan.io/address/0x605EA726F0259a30db5b7c9ef39Df9fE78665C44
export const sUSDe__USDe_Exchange_Rate = '0x605EA726F0259a30db5b7c9ef39Df9fE78665C44';

// https://arbiscan.io/address/0xb2A824043730FE05F3DA2efaFa1CBbe83fa548D6
export const ARB__USD = '0xb2A824043730FE05F3DA2efaFa1CBbe83fa548D6';

// https://arbiscan.io/address/0xE2A3216D8e4BdFA2Ee78F2e55B995e787e6Ce500
export const ORDER__USD = '0xE2A3216D8e4BdFA2Ee78F2e55B995e787e6Ce500';

// https://arbiscan.io/address/0x6303C35D49B13016A6acef5414893Fa7519E6da0
export const agETH__ETH_Exchange_Rate = '0x6303C35D49B13016A6acef5414893Fa7519E6da0';

// https://arbiscan.io/address/0x9BC7E5a6f1EED1C3217d2c63ad680DF83D84a906
export const wstUSR__stUSR_Exchange_Rate = '0x9BC7E5a6f1EED1C3217d2c63ad680DF83D84a906';

// https://arbiscan.io/address/0x256654437f1ADA8057684b18d742eFD14034C400
export const CAKE__USD = '0x256654437f1ADA8057684b18d742eFD14034C400';

// https://arbiscan.io/address/0x683989a7A6424122678164Ad26736bA484055B35
export const rswETH__ETH_Exchange_Rate = '0x683989a7A6424122678164Ad26736bA484055B35';

// https://arbiscan.io/address/0x594b919AD828e693B935705c3F816221729E7AE8
export const WTI__USD = '0x594b919AD828e693B935705c3F816221729E7AE8';

// https://arbiscan.io/address/0x703389807836463cff0CB01142dE903a74E509C4
export const YETH_ETH_Exchange_Rate = '0x703389807836463cff0CB01142dE903a74E509C4';

// https://arbiscan.io/address/0xf3451Fd5eddE08cDAE95A6233BaD69DE95552a61
export const XTZ__USD = '0xf3451Fd5eddE08cDAE95A6233BaD69DE95552a61';

// https://arbiscan.io/address/0x5d046567b97B0d7322F2402e3b34Bf789cE329f5
export const gmARB__USD = '0x5d046567b97B0d7322F2402e3b34Bf789cE329f5';

// https://arbiscan.io/address/0xe74d69E233faB0d8F48921f2D93aDfDe44cEb3B7
export const STG__USD = '0xe74d69E233faB0d8F48921f2D93aDfDe44cEb3B7';

// https://arbiscan.io/address/0x2C1C5eaB455A91cEAD280B12650faaA7bfDd59e6
export const AAVE_SVR_LINK__USD = '0x2C1C5eaB455A91cEAD280B12650faaA7bfDd59e6';

// https://arbiscan.io/address/0xF04bf09a664745c0a6404c885aCfe4f395335aB5
export const AAVE_SVR_LINK__USD_BASE = '0xF04bf09a664745c0a6404c885aCfe4f395335aB5';

// https://arbiscan.io/address/0x66853E19d73c0F9301fe099c324A1E9726953433
export const PENDLE__USD = '0x66853E19d73c0F9301fe099c324A1E9726953433';

// https://arbiscan.io/address/0x88d7538A4cD2664FCd610FE2a39b9ac01E430d3e
export const GLV_BTC_USDC___USD = '0x88d7538A4cD2664FCd610FE2a39b9ac01E430d3e';

// https://arbiscan.io/address/0xE89E98CE4E19071E59Ed4780E0598b541CE76486
export const GNS__USD = '0xE89E98CE4E19071E59Ed4780E0598b541CE76486';

// https://arbiscan.io/address/0x80dd57c45B73f3c70feAF1BFe1bcdF384703E558
export const ibBTC_PricePerShare = '0x80dd57c45B73f3c70feAF1BFe1bcdF384703E558';

// https://arbiscan.io/address/0xF3d6b05E69918d71807Ab005791daCcEC5de8C78
export const USDAI__USD = '0xF3d6b05E69918d71807Ab005791daCcEC5de8C78';

// https://arbiscan.io/address/0xf6DA27749484843c4F02f5Ad1378ceE723dD61d4
export const CAD__USD = '0xf6DA27749484843c4F02f5Ad1378ceE723dD61d4';

// https://arbiscan.io/address/0xe7C53FFd03Eb6ceF7d208bC4C13446c76d1E5884
export const COMP__USD = '0xe7C53FFd03Eb6ceF7d208bC4C13446c76d1E5884';

// https://arbiscan.io/address/0xBE5eA816870D11239c543F84b71439511D70B94f
export const BAL__USD = '0xBE5eA816870D11239c543F84b71439511D70B94f';

// https://arbiscan.io/address/0xBf4C6D59070F5649670E3d4f9033673D3489c4E9
export const RYT_NAV = '0xBf4C6D59070F5649670E3d4f9033673D3489c4E9';

// https://arbiscan.io/address/0xdE9f0894670c4EFcacF370426F10C3AD2Cdf147e
export const MKR__USD = '0xdE9f0894670c4EFcacF370426F10C3AD2Cdf147e';

// https://arbiscan.io/address/0x5C3e80763862CB777Aa07BDDBcCE0123104e1c34
export const frxETH_ETH_Exchange_Rate_High = '0x5C3e80763862CB777Aa07BDDBcCE0123104e1c34';

// https://arbiscan.io/address/0xd6a77691f071E98Df7217BED98f38ae6d2313EBA
export const AMZN__USD = '0xd6a77691f071E98Df7217BED98f38ae6d2313EBA';

// https://arbiscan.io/address/0xcfF9349ec6d027f20fC9360117fef4a1Ad38B488
export const RSR__USD = '0xcfF9349ec6d027f20fC9360117fef4a1Ad38B488';

// https://arbiscan.io/address/0xE2CB592D636c500a6e469628054F09d58e4d91BB
export const MELANIA__USD = '0xE2CB592D636c500a6e469628054F09d58e4d91BB';

// https://arbiscan.io/address/0x0809E3d38d1B4214958faf06D8b1B1a2b73f2ab8
export const FRAX__USD = '0x0809E3d38d1B4214958faf06D8b1B1a2b73f2ab8';

// https://arbiscan.io/address/0xdB0c64eFa0395063033b10769A80c62F885A620a
export const SYRUPUSDT__USD_Exchange_Rate = '0xdB0c64eFa0395063033b10769A80c62F885A620a';

// https://arbiscan.io/address/0xfF82AAF635645fD0bcc7b619C3F28004cDb58574
export const PHP__USD = '0xfF82AAF635645fD0bcc7b619C3F28004cDb58574';

// https://arbiscan.io/address/0xDde33fb9F21739602806580bdd73BAd831DcA867
export const MSFT__USD = '0xDde33fb9F21739602806580bdd73BAd831DcA867';

// https://arbiscan.io/address/0x0543Bb6b5A57E3e7569237b67321eAB773e41401
export const iBTC_Proof_of_Reserves = '0x0543Bb6b5A57E3e7569237b67321eAB773e41401';

// https://arbiscan.io/address/0x47E55cCec6582838E173f252D08Afd8116c2202d
export const MAGIC__USD = '0x47E55cCec6582838E173f252D08Afd8116c2202d';

// https://arbiscan.io/address/0xBafDf5307EaEF8dCd18c4b7b3977BEEB73b4AFE4
export const USR__USD = '0xBafDf5307EaEF8dCd18c4b7b3977BEEB73b4AFE4';

// https://arbiscan.io/address/0x04b7384473A2aDF1903E3a98aCAc5D62ba8C2702
export const BRL__USD = '0x04b7384473A2aDF1903E3a98aCAc5D62ba8C2702';

// https://arbiscan.io/address/0x98E5a52fB741347199C08a7a3fcF017364284431
export const sfrxETH_frxETH_Exchange_Rate = '0x98E5a52fB741347199C08a7a3fcF017364284431';

// https://arbiscan.io/address/0x950DC95D4E537A14283059bADC2734977C454498
export const COIN__USD = '0x950DC95D4E537A14283059bADC2734977C454498';

// https://arbiscan.io/address/0x54a82Bc6C6540F95C0b84690773635aCC97A92ff
export const SVR_ARB__USD = '0x54a82Bc6C6540F95C0b84690773635aCC97A92ff';

// https://arbiscan.io/address/0x78aabb7a55508bbCc3a76D2Dfd9ad4Ff97Afed7a
export const SVR_ARB__USD_BASE = '0x78aabb7a55508bbCc3a76D2Dfd9ad4Ff97Afed7a';

// https://arbiscan.io/address/0x0E278D14B4bf6429dDB0a1B353e2Ae8A4e128C93
export const SHIB__USD = '0x0E278D14B4bf6429dDB0a1B353e2Ae8A4e128C93';

// https://arbiscan.io/address/0x745Ab5b69E01E2BE1104Ca84937Bb71f96f5fB21
export const YFI__USD = '0x745Ab5b69E01E2BE1104Ca84937Bb71f96f5fB21';

// https://arbiscan.io/address/0x84ad1Cb9FDE786c00a77b7539344ad3C66A616f5
export const FBTC__BTC_Exchange_Rate = '0x84ad1Cb9FDE786c00a77b7539344ad3C66A616f5';

// https://arbiscan.io/address/0x3791D5eFF50Ab65fD82BBb16BCba42BEA556E7aA
export const GRASS__USD = '0x3791D5eFF50Ab65fD82BBb16BCba42BEA556E7aA';

// https://arbiscan.io/address/0xB49b8beB7b57E92416a122a495244D7cf2fE0bd4
export const AAVE_SVR_FRAX__USD = '0xB49b8beB7b57E92416a122a495244D7cf2fE0bd4';

// https://arbiscan.io/address/0x6AB8414a33065d4889049F6EBd202F1cb5e45537
export const AAVE_SVR_FRAX__USD_BASE = '0x6AB8414a33065d4889049F6EBd202F1cb5e45537';

// https://arbiscan.io/address/0x02DEd5a7EDDA750E3Eb240b54437a54d57b74dBE
export const PEPE__USD = '0x02DEd5a7EDDA750E3Eb240b54437a54d57b74dBE';

// https://arbiscan.io/address/0x726a96F31846f586E6a4C72F73c3dB671986a002
export const YBTC_BTC_Exchange_Rate = '0x726a96F31846f586E6a4C72F73c3dB671986a002';

// https://arbiscan.io/address/0x84e8237CC1418Ea1B4A1e0C3e7F48c3A5fbC81AF
export const AXL__USD = '0x84e8237CC1418Ea1B4A1e0C3e7F48c3A5fbC81AF';

// https://arbiscan.io/address/0xF7Ee427318d2Bd0EEd3c63382D0d52Ad8A68f90D
export const WIF__USD = '0xF7Ee427318d2Bd0EEd3c63382D0d52Ad8A68f90D';

// https://arbiscan.io/address/0xc2430cD1214F8452f4040473b7587195f9c565bD
export const ynETH__ETH_Exchange_Rate = '0xc2430cD1214F8452f4040473b7587195f9c565bD';

// https://arbiscan.io/address/0x9ca3D04Bdf90Ddc0074Ea57d3e2D331CD4b2d5a2
export const solvBTC__BTC = '0x9ca3D04Bdf90Ddc0074Ea57d3e2D331CD4b2d5a2';

// https://arbiscan.io/address/0x7537F8c0f8F7E7def07BF9e91e636e55881C7A66
export const SVR_FRAX__USD = '0x7537F8c0f8F7E7def07BF9e91e636e55881C7A66';

// https://arbiscan.io/address/0x16F384AeF73f3f3f7B566125b1f144Bc7c847b1E
export const SVR_FRAX__USD_BASE = '0x16F384AeF73f3f3f7B566125b1f144Bc7c847b1E';

// https://arbiscan.io/address/0x052d4200b624b07262F574af26C71A6553996Ab5
export const StaFi_Staked_ETH_rETH_ETH_Exchange_Rate = '0x052d4200b624b07262F574af26C71A6553996Ab5';

// https://arbiscan.io/address/0xA0118D8948FA85624608d94eC6B52973578082fA
export const stBTC_Proof_of_Reserves = '0xA0118D8948FA85624608d94eC6B52973578082fA';

// https://arbiscan.io/address/0x0F38D86FceF4955B705F35c9e41d1A16e0637c73
export const GRT__USD = '0x0F38D86FceF4955B705F35c9e41d1A16e0637c73';

// https://arbiscan.io/address/0x5Fb8E23065C362080E540e01e0bd4119B6cB53fe
export const Real_Final_Sales_to_Private_Domestic_Purchasers_Percent_Change_Annual_Rate =
  '0x5Fb8E23065C362080E540e01e0bd4119B6cB53fe';

// https://arbiscan.io/address/0x8b7C8726F93063b88Db512f34b90291AEB1E884B
export const BONE__USD = '0x8b7C8726F93063b88Db512f34b90291AEB1E884B';

// https://arbiscan.io/address/0xCDA67618e51762235eacA373894F0C79256768fa
export const ATOM__USD = '0xCDA67618e51762235eacA373894F0C79256768fa';

// https://arbiscan.io/address/0x920E09A98f83b82701207BA7E433a5b53eCB888A
export const ATH__USD = '0x920E09A98f83b82701207BA7E433a5b53eCB888A';

// https://arbiscan.io/address/0x9C4424Fd84C6661F97D8d6b3fc3C1aAc2BeDd137
export const GBP__USD = '0x9C4424Fd84C6661F97D8d6b3fc3C1aAc2BeDd137';

// https://arbiscan.io/address/0xD3631AC9D81eD560D61957a55E9c992cdE497eb6
export const egETH__ETH_Exchange_Rate = '0xD3631AC9D81eD560D61957a55E9c992cdE497eb6';

// https://arbiscan.io/address/0xaebDA2c976cfd1eE1977Eac079B4382acb849325
export const CRV__USD = '0xaebDA2c976cfd1eE1977Eac079B4382acb849325';

// https://arbiscan.io/address/0xA14d53bC1F1c0F31B4aA3BD109344E5009051a84
export const EUR__USD = '0xA14d53bC1F1c0F31B4aA3BD109344E5009051a84';

// https://arbiscan.io/address/0x639b7cD102A1c5BaB71c54f88D41E894215c54E2
export const SHIB__ETH = '0x639b7cD102A1c5BaB71c54f88D41E894215c54E2';

// https://arbiscan.io/address/0x4763b84cdBc5211B9e0a57D5E39af3B3b2440012
export const Total_Marketcap_USD = '0x4763b84cdBc5211B9e0a57D5E39af3B3b2440012';

// https://arbiscan.io/address/0x4096b9bfB4c34497B7a3939D4f629cf65EBf5634
export const TIA__USD = '0x4096b9bfB4c34497B7a3939D4f629cf65EBf5634';

// https://arbiscan.io/address/0x0518673439245BB95A58688Bc31cd513F3D5bDd6
export const cbETH_ETH_Exchange_Rate = '0x0518673439245BB95A58688Bc31cd513F3D5bDd6';

// https://arbiscan.io/address/0xF0d38324d1F86a176aC727A4b0c43c9F9d9c5EB1
export const SGD__USD = '0xF0d38324d1F86a176aC727A4b0c43c9F9d9c5EB1';

// https://arbiscan.io/address/0xF8722c901675C4F2F7824E256B8A6477b2c105FB
export const syrupUSDC__USDC_Exchange_Rate = '0xF8722c901675C4F2F7824E256B8A6477b2c105FB';

// https://arbiscan.io/address/0x395D5c5D552Df670dc4B2B1cef0c4EABfFba492f
export const gmBTC__USD = '0x395D5c5D552Df670dc4B2B1cef0c4EABfFba492f';

// https://arbiscan.io/address/0x5e2b5C5C07cCA3437c4D724225Bb42c7E55d1597
export const WOO__USD = '0x5e2b5C5C07cCA3437c4D724225Bb42c7E55d1597';

// https://arbiscan.io/address/0xF6a5c5480A9aC736ea567454e2E570889E0DB4Bc
export const frxUSD__USD = '0xF6a5c5480A9aC736ea567454e2E570889E0DB4Bc';

// https://arbiscan.io/address/0xE8f8AfE4b56c6C421F691bfAc225cE61b2C7CD05
export const TRY__USD = '0xE8f8AfE4b56c6C421F691bfAc225cE61b2C7CD05';

// https://arbiscan.io/address/0x8883045300Eaf3b1Bb1b3b17F9B4d70EfF50212a
export const ULTI__USD = '0x8883045300Eaf3b1Bb1b3b17F9B4d70EfF50212a';

// https://arbiscan.io/address/0x9eE96caa9972c801058CAA8E23419fc6516FbF7e
export const ENA__USD = '0x9eE96caa9972c801058CAA8E23419fc6516FbF7e';

// https://arbiscan.io/address/0x24ceA4b8ce57cdA5058b924B9B9987992450590c
export const SOL__USD = '0x24ceA4b8ce57cdA5058b924B9B9987992450590c';

// https://arbiscan.io/address/0xAE8B4179389059A735821A77417eACcA60f3e4B4
export const xSolvBTC_NAV = '0xAE8B4179389059A735821A77417eACcA60f3e4B4';

// https://arbiscan.io/address/0x0C997958ccE7A0403AEA7E34d14bbaDA897B5bb3
export const PUMP__USD = '0x0C997958ccE7A0403AEA7E34d14bbaDA897B5bb3';

// https://arbiscan.io/address/0x2483326d19f780Fb082f333Fe124e4C075B207ba
export const sUSDS__USDS_Exchange_Rate = '0x2483326d19f780Fb082f333Fe124e4C075B207ba';

// https://arbiscan.io/address/0x300b0990Ba191a1AeBef6e5Ed8B5B308C0B2d0c9
export const XVS__USD = '0x300b0990Ba191a1AeBef6e5Ed8B5B308C0B2d0c9';

// https://arbiscan.io/address/0xe4c31C5B118d8aA92433eD1c7EC70afb430cd730
export const TBTC__BTC = '0xe4c31C5B118d8aA92433eD1c7EC70afb430cd730';

// https://arbiscan.io/address/0x989a480b6054389075CBCdC385C18CfB6FC08186
export const ezETH__ETH_Exchange_Rate = '0x989a480b6054389075CBCdC385C18CfB6FC08186';

// https://arbiscan.io/address/0x4f861F14246229530a881D32C8d26D78b8c48BE6
export const BERA__USD = '0x4f861F14246229530a881D32C8d26D78b8c48BE6';

// https://arbiscan.io/address/0x20bAe7e1De9c596f5F7615aeaa1342Ba99294e12
export const weETH__eETH_Exchange_Rate = '0x20bAe7e1De9c596f5F7615aeaa1342Ba99294e12';

// https://arbiscan.io/address/0x6ce185860a4963106506C203335A2910413708e9
export const BTC__USD = '0x6ce185860a4963106506C203335A2910413708e9';

// https://arbiscan.io/address/0x20d0Fcab0ECFD078B036b6CAf1FaC69A6453b352
export const RDNT__USD = '0x20d0Fcab0ECFD078B036b6CAf1FaC69A6453b352';

// https://arbiscan.io/address/0xD07de6e37A011CCAfD375d7eb130205E0fa24d69
export const MLN__USD = '0xD07de6e37A011CCAfD375d7eb130205E0fa24d69';

// https://arbiscan.io/address/0x86E53CF1B870786351Da77A57575e79CB55812CB
export const LINK__USD = '0x86E53CF1B870786351Da77A57575e79CB55812CB';

// https://arbiscan.io/address/0x6970460aabF80C5BE983C6b74e5D06dEDCA95D4A
export const BNB__USD = '0x6970460aabF80C5BE983C6b74e5D06dEDCA95D4A';

// https://arbiscan.io/address/0xF9329B38084cbE893894F19a518Fc6Cd306D9930
export const GLV_WETH_USDC___USD = '0xF9329B38084cbE893894F19a518Fc6Cd306D9930';

// https://arbiscan.io/address/0xE141425bc1594b8039De6390db1cDaf4397EA22b
export const weETH__ETH = '0xE141425bc1594b8039De6390db1cDaf4397EA22b';

// https://arbiscan.io/address/0x36194c6DBB4218036d5f1ef070e9900896f84e06
export const AoABT_NAV = '0x36194c6DBB4218036d5f1ef070e9900896f84e06';

// https://arbiscan.io/address/0x5B58aA6E0651Ae311864876A55411F481aD86080
export const AXS__USD = '0x5B58aA6E0651Ae311864876A55411F481aD86080';

// https://arbiscan.io/address/0x52099D4523531f678Dfc568a7B1e5038aadcE1d6
export const MATIC__USD = '0x52099D4523531f678Dfc568a7B1e5038aadcE1d6';

// https://arbiscan.io/address/0x06047dD6f43552831BB51319917DC0C99c29A44c
export const SVR_BTC__USD = '0x06047dD6f43552831BB51319917DC0C99c29A44c';

// https://arbiscan.io/address/0x1C8a384aF067418f631683262965F7B5d1e5C788
export const SVR_BTC__USD_BASE = '0x1C8a384aF067418f631683262965F7B5d1e5C788';

// https://arbiscan.io/address/0x004f214586CaFE0F1321Ad13A93bca77C385b196
export const PLUME__USD = '0x004f214586CaFE0F1321Ad13A93bca77C385b196';

// https://arbiscan.io/address/0xA9cC9B5Ea2584239365Ea6b985868D121CB7Aea6
export const ZAR__USD = '0xA9cC9B5Ea2584239365Ea6b985868D121CB7Aea6';

// https://arbiscan.io/address/0x6aCcBB82aF71B8a576B4C05D4aF92A83A035B991
export const TAO__USD = '0x6aCcBB82aF71B8a576B4C05D4aF92A83A035B991';

// https://arbiscan.io/address/0x47A2fBEb46553F01E7133686Fb1b5349d4823a0C
export const dlcBTC_Proof_of_Reserves = '0x47A2fBEb46553F01E7133686Fb1b5349d4823a0C';

// https://arbiscan.io/address/0xcd1bd86fDc33080DCF1b5715B6FCe04eC6F85845
export const META__USD = '0xcd1bd86fDc33080DCF1b5715B6FCe04eC6F85845';

// https://arbiscan.io/address/0x37DDEE84dE03d039e1Bf809b7a01EDd2c4665771
export const MNT__USD = '0x37DDEE84dE03d039e1Bf809b7a01EDd2c4665771';

// https://arbiscan.io/address/0x339a66699167D8bc7105C4B9772492D2576E5183
export const AAVE_SVR_ARB__USD = '0x339a66699167D8bc7105C4B9772492D2576E5183';

// https://arbiscan.io/address/0xa631dEfF664Da5A42642c3E1A4a8d5b4F99Ee28D
export const AAVE_SVR_ARB__USD_BASE = '0xa631dEfF664Da5A42642c3E1A4a8d5b4F99Ee28D';

// https://arbiscan.io/address/0x326fA29b208DE897981C78827b8ffDbfa355590b
export const Real_GDP_Level = '0x326fA29b208DE897981C78827b8ffDbfa355590b';

// https://arbiscan.io/address/0xded2c52b75B24732e9107377B7Ba93eC1fFa4BAf
export const STETH__ETH = '0xded2c52b75B24732e9107377B7Ba93eC1fFa4BAf';

// https://arbiscan.io/address/0x88AC7Bca36567525A866138F03a6F6844868E0Bc
export const USDe__USD = '0x88AC7Bca36567525A866138F03a6F6844868E0Bc';

// https://arbiscan.io/address/0xF18BE32dB91591A7256d738C166FA195a17457DA
export const uniETH__ETH_Exchange_Rate = '0xF18BE32dB91591A7256d738C166FA195a17457DA';

// https://arbiscan.io/address/0xF230542B263Ad8F37a4c6d640F42BcE2Ec7C6cA3
export const FRAGSOL__SOL_Exchange_Rate = '0xF230542B263Ad8F37a4c6d640F42BcE2Ec7C6cA3';

// https://arbiscan.io/address/0xFdB631F5EE196F0ed6FAa767959853A9F217697D
export const L2_Sequencer_Uptime_Status_Feed = '0xFdB631F5EE196F0ed6FAa767959853A9F217697D';

// https://arbiscan.io/address/0xA43A34030088E6510FecCFb77E88ee5e7ed0fE64
export const LDO__USD = '0xA43A34030088E6510FecCFb77E88ee5e7ed0fE64';

// https://arbiscan.io/address/0x229a9322D050BB6aC91C40fFbB8e3bef79c48071
export const USR_USD_Exchange_Rate = '0x229a9322D050BB6aC91C40fFbB8e3bef79c48071';

// https://arbiscan.io/address/0x1940fEd49cDBC397941f2D336eb4994D599e568B
export const ZRO__USD = '0x1940fEd49cDBC397941f2D336eb4994D599e568B';

// https://arbiscan.io/address/0xea320E4d688B143A3bFBF1b4a5cc4B986fCa086c
export const CRO__USD = '0xea320E4d688B143A3bFBF1b4a5cc4B986fCa086c';

// https://arbiscan.io/address/0xE808488e8627F6531bA79a13A9E0271B39abEb1C
export const TBTC__USD = '0xE808488e8627F6531bA79a13A9E0271B39abEb1C';

// https://arbiscan.io/address/0x3f3f5dF88dC9F13eac63DF89EC16ef6e7E25DdE7
export const USDT__USD = '0x3f3f5dF88dC9F13eac63DF89EC16ef6e7E25DdE7';

// https://arbiscan.io/address/0xB4102D5E72c402D537C9f024F4bd9c3709FE200d
export const osETH__ETH_Exchange_Rate = '0xB4102D5E72c402D537C9f024F4bd9c3709FE200d';

// https://arbiscan.io/address/0xFeaC1A3936514746e70170c0f539e70b23d36F19
export const S__USD = '0xFeaC1A3936514746e70170c0f539e70b23d36F19';

// https://arbiscan.io/address/0x373510BDa1ab7e873c731968f4D81B685f520E4B
export const TRUMP__USD = '0x373510BDa1ab7e873c731968f4D81B685f520E4B';

// https://arbiscan.io/address/0xd9344493d99153Ad4353D604A1d80d4089004c5D
export const zBTC_Proof_of_Reserves = '0xd9344493d99153Ad4353D604A1d80d4089004c5D';

// https://arbiscan.io/address/0x3A917e6B5732dFCc4A45257e3930979fAE6a3737
export const rsETH__ETH_Exchange_Rate = '0x3A917e6B5732dFCc4A45257e3930979fAE6a3737';

// https://arbiscan.io/address/0x07C5b924399cc23c24a95c8743DE4006a32b7f2a
export const STETH__USD = '0x07C5b924399cc23c24a95c8743DE4006a32b7f2a';

// https://arbiscan.io/address/0xDe4Af8b4747192Ea29339D0FeB36d9830d399134
export const AAVE_SVR_BTC__USD = '0xDe4Af8b4747192Ea29339D0FeB36d9830d399134';

// https://arbiscan.io/address/0xd0e9220a422bA14676DC34042f5f70c6fbc3F7AF
export const AAVE_SVR_BTC__USD_BASE = '0xd0e9220a422bA14676DC34042f5f70c6fbc3F7AF';

// https://arbiscan.io/address/0x1b47b4124b9A5094C59710E6b9126e5e32a4fb8E
export const XPL__USD = '0x1b47b4124b9A5094C59710E6b9126e5e32a4fb8E';

// https://arbiscan.io/address/0x6fAbee62266Da6686EE2744C6f15bb8352d2f28D
export const TUSD__USD = '0x6fAbee62266Da6686EE2744C6f15bb8352d2f28D';

// https://arbiscan.io/address/0xCF9752295D0ac9215461fA095faFEC1B854b849B
export const EURC__USD = '0xCF9752295D0ac9215461fA095faFEC1B854b849B';

// https://arbiscan.io/address/0xc6984fF1047Ddd0AB52D2dFa78381CC677921A85
export const GLV_BTC_USDC_USD = '0xc6984fF1047Ddd0AB52D2dFa78381CC677921A85';

// https://arbiscan.io/address/0xe32AccC8c4eC03F6E75bd3621BfC9Fbb234E1FC3
export const CHF__USD = '0xe32AccC8c4eC03F6E75bd3621BfC9Fbb234E1FC3';

// https://arbiscan.io/address/0x3C5C5329b028E674F7a124b18527B94BE74A66cF
export const inETH__ETH_Exchange_Rate = '0x3C5C5329b028E674F7a124b18527B94BE74A66cF';

// https://arbiscan.io/address/0xDB98056FecFff59D032aB628337A4887110df3dB
export const GMX__USD = '0xDB98056FecFff59D032aB628337A4887110df3dB';

// https://arbiscan.io/address/0x368B55bEb0d85aBe2bD04C7cba5Bd640A53fCF37
export const AAVE_SVR_DAI__USD = '0x368B55bEb0d85aBe2bD04C7cba5Bd640A53fCF37';

// https://arbiscan.io/address/0x103C63BdD0497422f4DfD6BdC14F6799d24B29a5
export const AAVE_SVR_DAI__USD_BASE = '0x103C63BdD0497422f4DfD6BdC14F6799d24B29a5';

// https://arbiscan.io/address/0x5082d93991DfCc69F57a27CEC63EDEe1B8C22757
export const HKD__USD = '0x5082d93991DfCc69F57a27CEC63EDEe1B8C22757';

// https://arbiscan.io/address/0xc5C8E77B397E531B8EC06BFb0048328B30E9eCfB
export const DAI__USD = '0xc5C8E77B397E531B8EC06BFb0048328B30E9eCfB';

// https://arbiscan.io/address/0x806c532D543352e7C344ba6C7F3F00Bfbd309Af1
export const XAI__USD = '0x806c532D543352e7C344ba6C7F3F00Bfbd309Af1';

// https://arbiscan.io/address/0x0a32255dd4BB6177C994bAAc73E0606fDD568f66
export const CRVUSD__USD = '0x0a32255dd4BB6177C994bAAc73E0606fDD568f66';

// https://arbiscan.io/address/0x670BD6D743fa996dC512e2c652b7c8FFa8E7C23F
export const SVR_EURC__USD = '0x670BD6D743fa996dC512e2c652b7c8FFa8E7C23F';

// https://arbiscan.io/address/0x730a28C2B674e7D2c3e168337BfB2dD82ac1A67D
export const SVR_EURC__USD_BASE = '0x730a28C2B674e7D2c3e168337BfB2dD82ac1A67D';

// https://arbiscan.io/address/0xb7c8Fb1dB45007F98A68Da0588e1AA524C317f27
export const LINK__ETH = '0xb7c8Fb1dB45007F98A68Da0588e1AA524C317f27';

// https://arbiscan.io/address/0xba55b9d246d351278f1Ec3bacdDe414caC8006D7
export const SVR_DAI__USD = '0xba55b9d246d351278f1Ec3bacdDe414caC8006D7';

// https://arbiscan.io/address/0xFa74Da2Fc3d7ADaA6Fc1136eA1690ccD5E2d242C
export const SVR_DAI__USD_BASE = '0xFa74Da2Fc3d7ADaA6Fc1136eA1690ccD5E2d242C';

// https://arbiscan.io/address/0xDC1a8F77Cdc46D1Fb7F22F94dFCA4dDBf566fA23
export const Real_GDP_Percent_Change_Annual_Rate = '0xDC1a8F77Cdc46D1Fb7F22F94dFCA4dDBf566fA23';

// https://arbiscan.io/address/0x04180965a782E487d0632013ABa488A472243542
export const JOE__USD = '0x04180965a782E487d0632013ABa488A472243542';

// https://arbiscan.io/address/0x1f5C0C2CD2e9Ad1eE475660AF0bBa27aE7d87f5e
export const ETHx__ETH_Exchange_Rate = '0x1f5C0C2CD2e9Ad1eE475660AF0bBa27aE7d87f5e';

// https://arbiscan.io/address/0xC1D05bAd3Acd3D11329c9A6e417A613d32aC4a78
export const AoABTb_NAV = '0xC1D05bAd3Acd3D11329c9A6e417A613d32aC4a78';

// https://arbiscan.io/address/0xbD41b1548a5A06544cBcf87c0c54864312842C00
export const AAVE_SVR_ETH__USD = '0xbD41b1548a5A06544cBcf87c0c54864312842C00';

// https://arbiscan.io/address/0xAfF2135E3CE17578929C0ab714e2923f0C40b0DC
export const AAVE_SVR_ETH__USD_BASE = '0xAfF2135E3CE17578929C0ab714e2923f0C40b0DC';

// https://arbiscan.io/address/0x98a977Ba31C72aeF2e15B950Eb5Ae3158863D856
export const tETH__wstETH_Exchange_Rate = '0x98a977Ba31C72aeF2e15B950Eb5Ae3158863D856';

// https://arbiscan.io/address/0x4bC735Ef24bf286983024CAd5D03f0738865Aaef
export const _1INCH__USD = '0x4bC735Ef24bf286983024CAd5D03f0738865Aaef';

// https://arbiscan.io/address/0xb39082aA764c8EbEb91F196E31cE0E570b1A268C
export const AAVE_SVR_LUSD__USD = '0xb39082aA764c8EbEb91F196E31cE0E570b1A268C';

// https://arbiscan.io/address/0x7A8A9aD4AeE9B8cF491de61c03834eb364A4EED1
export const AAVE_SVR_LUSD__USD_BASE = '0x7A8A9aD4AeE9B8cF491de61c03834eb364A4EED1';

// https://arbiscan.io/address/0x3b9c34dC5B6BfC1dE896496aFCEf1ca705D0c762
export const XDC__USD = '0x3b9c34dC5B6BfC1dE896496aFCEf1ca705D0c762';

// https://arbiscan.io/address/0x3dD6e51CB9caE717d5a8778CF79A04029f9cFDF8
export const JPY__USD = '0x3dD6e51CB9caE717d5a8778CF79A04029f9cFDF8';

// https://arbiscan.io/address/0xd0C7101eACbB49F3deCcCc166d238410D6D46d57
export const WBTC__USD = '0xd0C7101eACbB49F3deCcCc166d238410D6D46d57';

// https://arbiscan.io/address/0xB1552C5e96B312d0Bf8b554186F846C40614a540
export const wstETH_stETH_Exchange_Rate = '0xB1552C5e96B312d0Bf8b554186F846C40614a540';

// https://arbiscan.io/address/0xbcD8bEA7831f392bb019ef3a672CC15866004536
export const CV_Index = '0xbcD8bEA7831f392bb019ef3a672CC15866004536';

// https://arbiscan.io/address/0xdc49F292ad1bb3DAb6C11363d74ED06F38b9bd9C
export const APT__USD = '0xdc49F292ad1bb3DAb6C11363d74ED06F38b9bd9C';

// https://arbiscan.io/address/0x021126143D0B6e20Bb69beFcc860e7E523df8055
export const SUSDAI__USD = '0x021126143D0B6e20Bb69beFcc860e7E523df8055';

// https://arbiscan.io/address/0xBF5C3fB2633e924598A46B9D07a174a9DBcF57C0
export const NEAR__USD = '0xBF5C3fB2633e924598A46B9D07a174a9DBcF57C0';

// https://arbiscan.io/address/0x9A7FB1b3950837a8D9b40517626E11D4127C098C
export const DOGE__USD = '0x9A7FB1b3950837a8D9b40517626E11D4127C098C';

// https://arbiscan.io/address/0xa668682974E3f121185a3cD94f00322beC674275
export const CBETH__ETH = '0xa668682974E3f121185a3cD94f00322beC674275';

// https://arbiscan.io/address/0x29D57534598BF8Adda2CC2FbDe4B7502387B8177
export const RON__USD = '0x29D57534598BF8Adda2CC2FbDe4B7502387B8177';

// https://arbiscan.io/address/0xf97eEAac36bdd096bb2445c7582F9095bfCE04C7
export const AAVE_SVR_AAVE__USD = '0xf97eEAac36bdd096bb2445c7582F9095bfCE04C7';

// https://arbiscan.io/address/0xd01d5e889659d33AAF01B34b1D41123F07B11B57
export const AAVE_SVR_AAVE__USD_BASE = '0xd01d5e889659d33AAF01B34b1D41123F07B11B57';

// https://arbiscan.io/address/0xA33a06c119EC08F92735F9ccA37e07Af08C4f281
export const DODO__USD = '0xA33a06c119EC08F92735F9ccA37e07Af08C4f281';

// https://arbiscan.io/address/0x59644ec622243878d1464A9504F9e9a31294128a
export const MIMATIC__USD = '0x59644ec622243878d1464A9504F9e9a31294128a';

// https://arbiscan.io/address/0x3861d83ed006A6570cE8Eb9878F4Df0dF889A2da
export const RLP_USD_Exchange_Rate = '0x3861d83ed006A6570cE8Eb9878F4Df0dF889A2da';

// https://arbiscan.io/address/0x76998C22eEa325A11dc6971Cedcf533E9740F854
export const ORDI__USD = '0x76998C22eEa325A11dc6971Cedcf533E9740F854';

// https://arbiscan.io/address/0xa677622735c38001fd1183c92dc5b889128EC234
export const uniBTC__BTC_Exchange_Rate = '0xa677622735c38001fd1183c92dc5b889128EC234';

// https://arbiscan.io/address/0x8bf61728eeDCE2F32c456454d87B5d6eD6150208
export const AVAX__USD = '0x8bf61728eeDCE2F32c456454d87B5d6eD6150208';

// https://arbiscan.io/address/0xdE89a55d04DEd40A410877ab87d4F567ee66a1f0
export const SEK__USD = '0xdE89a55d04DEd40A410877ab87d4F567ee66a1f0';

// https://arbiscan.io/address/0x3d50d699A812A0f66F36876DF47B2aE68e781736
export const PYUSD__USD = '0x3d50d699A812A0f66F36876DF47B2aE68e781736';

// https://arbiscan.io/address/0xCc9742d77622eE9abBF1Df03530594f9097bDcB3
export const SEI__USD = '0xCc9742d77622eE9abBF1Df03530594f9097bDcB3';

// https://arbiscan.io/address/0x1F954Dc24a49708C26E0C1777f16750B5C6d5a2c
export const XAU__USD = '0x1F954Dc24a49708C26E0C1777f16750B5C6d5a2c';

// https://arbiscan.io/address/0x702609AFaDda5b357bc7b0C5174645a4438A99F3
export const JLP__USD = '0x702609AFaDda5b357bc7b0C5174645a4438A99F3';

// https://arbiscan.io/address/0x70E48a135F76bA31B47FE944e769E052A8FeB849
export const ASTR__USD = '0x70E48a135F76bA31B47FE944e769E052A8FeB849';

// https://arbiscan.io/address/0x4Ee1f9ec1048979930aC832a3C1d18a0b4955a02
export const USDD__USD = '0x4Ee1f9ec1048979930aC832a3C1d18a0b4955a02';

// https://arbiscan.io/address/0x82BA56a2fADF9C14f17D08bc51bDA0bDB83A8934
export const POL__USD = '0x82BA56a2fADF9C14f17D08bc51bDA0bDB83A8934';

// https://arbiscan.io/address/0x03e4054B11ad01915257bE53Af03A32Abf7837b9
export const sFRAX__FRAX_Exchange_Rate = '0x03e4054B11ad01915257bE53Af03A32Abf7837b9';

// https://arbiscan.io/address/0xb2A8BA74cbca38508BA1632761b56C897060147C
export const SUSHI__USD = '0xb2A8BA74cbca38508BA1632761b56C897060147C';

// https://arbiscan.io/address/0x41f8459f911658e9C627c5D1d2Fb18c7dbc8ceBe
export const apxETH__pxETH_Exchange_Rate = '0x41f8459f911658e9C627c5D1d2Fb18c7dbc8ceBe';

// https://arbiscan.io/address/0x037100C673E8A63fBF8F6f78A8FBeEbb683593a8
export const CORE__USD = '0x037100C673E8A63fBF8F6f78A8FBeEbb683593a8';

// https://arbiscan.io/address/0x02E892E7F49dFEb8B26563150047C7c33D148e40
export const SVR_LUSD__USD = '0x02E892E7F49dFEb8B26563150047C7c33D148e40';

// https://arbiscan.io/address/0xb2Ae7b3457C86120134E2a0B9374662dE46b801F
export const SVR_LUSD__USD_BASE = '0xb2Ae7b3457C86120134E2a0B9374662dE46b801F';

// https://arbiscan.io/address/0xb0EA543f9F8d4B818550365d13F66Da747e1476A
export const RSETH__ETH = '0xb0EA543f9F8d4B818550365d13F66Da747e1476A';

// https://arbiscan.io/address/0x19eCDd6DDc12597ec4A522fB1E25b1A580B605B7
export const GM_BTC__USD_WBTC_WBTC = '0x19eCDd6DDc12597ec4A522fB1E25b1A580B605B7';

// https://arbiscan.io/address/0x552c92c0C09A73d569Ab52FF4C17a153C3472BE3
export const PCE_Price_Index_Percent_Change_Annual_Rate =
  '0x552c92c0C09A73d569Ab52FF4C17a153C3472BE3';

// https://arbiscan.io/address/0xfB3264D1129824933a52374c2C1696F4470D041e
export const gmETH__USD = '0xfB3264D1129824933a52374c2C1696F4470D041e';

// https://arbiscan.io/address/0x0225781042C46dB247e009FFEAd5aEf044f3E7BE
export const MON__USD = '0x0225781042C46dB247e009FFEAd5aEf044f3E7BE';

// https://arbiscan.io/address/0xD9f615A9b820225edbA2d821c4A696a0924051c6
export const ADA__USD = '0xD9f615A9b820225edbA2d821c4A696a0924051c6';

// https://arbiscan.io/address/0x9C917083fDb403ab5ADbEC26Ee294f6EcAda2720
export const UNI__USD = '0x9C917083fDb403ab5ADbEC26Ee294f6EcAda2720';

// https://arbiscan.io/address/0xF6897122530ca89beB919f5990FDd3F7Cc9837C4
export const ynETHx__ETH_Exchange_Rate = '0xF6897122530ca89beB919f5990FDd3F7Cc9837C4';

// https://arbiscan.io/address/0xD2385f41995499bBF255cE0A1486ebCe3Dca0e5D
export const M_NAV = '0xD2385f41995499bBF255cE0A1486ebCe3Dca0e5D';

// https://arbiscan.io/address/0x20b0159404886F4BFE51A1ad9c14cFc3Cde5995c
export const ultraETHs__ETH_Exchange_Rate = '0x20b0159404886F4BFE51A1ad9c14cFc3Cde5995c';

// https://arbiscan.io/address/0xEAeFFF521cb36dFb414E8580f8635BFB44d96255
export const GM_ETH__USD_wETH_wETH = '0xEAeFFF521cb36dFb414E8580f8635BFB44d96255';

// https://arbiscan.io/address/0x066Ba4567C40cB315EAd257Bd86585bb4a74004f
export const PCE_Price_Index_Level = '0x066Ba4567C40cB315EAd257Bd86585bb4a74004f';

// https://arbiscan.io/address/0x383b3624478124697BEF675F07cA37570b73992f
export const SPELL__USD = '0x383b3624478124697BEF675F07cA37570b73992f';

// https://arbiscan.io/address/0x36a121448D74Fa81450c992A1a44B9b7377CD3a5
export const FXS__USD = '0x36a121448D74Fa81450c992A1a44B9b7377CD3a5';

// https://arbiscan.io/address/0x6FfBc6339DD46a7e0513D4887106349214C05505
export const WEMIX__USD = '0x6FfBc6339DD46a7e0513D4887106349214C05505';

// https://arbiscan.io/address/0xCF7a7A1Fb746E926Bbe5C88a702a89167a94C51C
export const GAS__USD = '0xCF7a7A1Fb746E926Bbe5C88a702a89167a94C51C';

// https://arbiscan.io/address/0x1bD872f3A606471787B1a304cE0356e4e87Af930
export const frxETH_ETH_Exchange_Rate_Low = '0x1bD872f3A606471787B1a304cE0356e4e87Af930';

export const CHAIN_ID = 42161;
